import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import TurboCashThanksView from '../../../components/views/mx/turboCash/TurboCashThanksView';

const mapStateToProps = (state, {match, landing}) => {
    return {
        landing
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onPressGotoHome: () => {
            dispatch(WizardMXActions.CLEAN_STATE_ONCE_FINISHED_LOAN_TURBO_CASH.action());
            dispatch(WizardMXActions.GO_TO_HOME_ACTION.action());
        },
    };
};

const TurboCashThanksContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps
)(TurboCashThanksView));

export default TurboCashThanksContainer;